/* ═══════════════════════════════════════════════════════════════════════════════
   DashboardFilterContext: Context object only
   
   Extracted to a pure .ts file so the Provider component file satisfies
   react-refresh/only-export-components.
   ═══════════════════════════════════════════════════════════════════════════════ */

import { createContext } from 'react';
import type { DashboardFilterContextValue } from '../types/dashboard-filters';

export const DashboardFilterContext = createContext<DashboardFilterContextValue | null>(null);
